"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
function getLocalize() {
    if (typeof Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return Localize;
}
;
/* istanbul ignore next */
function getLocalizeFormat() {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
}
/* istanbul ignore next */
exports.LocaleData = { get: function () { return getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    notUpdated: function () { return t('@tableau__metrics-shared-widgets-dom/notUpdated'); },
    syncedDate: function (a) { return t('@tableau__metrics-shared-widgets-dom/syncedDate', a); },
    syncedAtTime: function (a) { return t('@tableau__metrics-shared-widgets-dom/syncedAtTime', a); },
    selectedDate: function (a) { return t('@tableau__metrics-shared-widgets-dom/selectedDate', a); },
    noData: function () { return t('@tableau__metrics-shared-widgets-dom/noData'); },
    refreshedSince: function (a) { return t('@tableau__metrics-shared-widgets-dom/refreshedSince', a); },
    metricDetails: function () { return t('@tableau__metrics-shared-widgets-dom/metricDetails'); },
    owner: function () { return t('@tableau__metrics-shared-widgets-dom/owner'); },
    description: function () { return t('@tableau__metrics-shared-widgets-dom/description'); },
    connectedView: function () { return t('@tableau__metrics-shared-widgets-dom/connectedView'); },
    connectedViewSubTitle: function () { return t('@tableau__metrics-shared-widgets-dom/connectedViewSubTitle'); },
    definition: function () { return t('@tableau__metrics-shared-widgets-dom/definition'); },
    measure: function () { return t('@tableau__metrics-shared-widgets-dom/measure'); },
    dateDimension: function () { return t('@tableau__metrics-shared-widgets-dom/dateDimension'); },
    project: function () { return t('@tableau__metrics-shared-widgets-dom/project'); },
    modified: function () { return t('@tableau__metrics-shared-widgets-dom/modified'); },
    tags: function () { return t('@tableau__metrics-shared-widgets-dom/tags'); },
    weekOf: function (a) { return t('@tableau__metrics-shared-widgets-dom/weekOf', a); },
};
exports.Formatters = {
    timeWithSeconds: function (a) { return getLocalizeFormat().formatDate(a, { "time": "medium" }); },
    dateWithTimeToMinute: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMdhm" }); },
    dateWithTimeToHour: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMdh" }); },
    slashDate: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMd" }); },
    slashMonthYear: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yM" }); },
    quarterYear: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yQQQ" }); },
    year: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "y" }); },
    wordyDateWithTimeToSecond: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMMMdhms" }); },
    wordyDateWithTimeToMinute: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMMMdhm" }); },
    wordyDateWithTimeToHour: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMMMdh" }); },
    wordyDate: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMMMd" }); },
    wordyMonthYear: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "yMMM" }); },
    month: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "MMM" }); },
    monthAndDay: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "MMMd" }); },
    timeToMinute: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "hm" }); },
    timeToHour: function (a) { return getLocalizeFormat().formatDate(a, { "skeleton": "h" }); },
};
//# sourceMappingURL=Localize.js.map